/* eslint-disable security/detect-object-injection */

import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'nordic/image';
import { getWaveSectionContent } from '../../content/waveSection';

const WaveSection = ({ children }) => {
  const { divider: { imageUrl } } = getWaveSectionContent();
  return (
    <section className="wave-section">
      <Image className="wave-section__image" onload="on" src={imageUrl} alt="ware-divider" />
      {children}
    </section>
  );
};

WaveSection.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.element,
  ).isRequired,
};

export default WaveSection;
